/**
 * Firebase JS SDK initialization.
 *
 * Both configs are included at build time (client-side API keys are NOT secret
 * — security is enforced via Firebase Security Rules and App Check).
 *
 * Environment selection:
 *   REACT_APP_FIREBASE_ENV=production  → uses prod project
 *   anything else (default)            → uses staging project
 *
 * When REACT_APP_FIREBASE_ENV is not set (local dev / CI without it), staging
 * is used so production data is never touched during development.
 */

import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const CONFIGS = {
  staging: {
    apiKey:            'AIzaSyD0cYwTWdlUbyGI9mfonR9WpTkZabuDpJ4',
    authDomain:        'fusionquery-staging.firebaseapp.com',
    projectId:         'fusionquery-staging',
    storageBucket:     'fusionquery-staging.firebasestorage.app',
    messagingSenderId: '371866078306',
    appId:             '1:371866078306:web:12f7b9a340696c7cf6953b',
    measurementId:     'G-ZVBS4TSGJV',
  },
  production: {
    apiKey:            'AIzaSyCfWi2BPKDxy5pB5AhBOjJkffrRgV7q7iE',
    authDomain:        'fusionquery-prod.firebaseapp.com',
    projectId:         'fusionquery-prod',
    storageBucket:     'fusionquery-prod.firebasestorage.app',
    messagingSenderId: '962035720938',
    appId:             '1:962035720938:web:d394542d0d3957ae89ad93',
    measurementId:     'G-LSTD9QKTZ1',
  },
};

const env = process.env.REACT_APP_FIREBASE_ENV === 'production' ? 'production' : 'staging';
const firebaseConfig = CONFIGS[env];

export const firebaseApp  = initializeApp(firebaseConfig);
export const firebaseAuth = getAuth(firebaseApp);
export const firebaseDb   = getFirestore(firebaseApp);
export { env as firebaseEnv };
